import React, { useEffect, useMemo, useRef, useState } from "react";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { usePictureSet } from "../../hooks/usePictureSet";
import { Card, CardActions, CardContent, Container } from "@material-ui/core";
import EpmsImage from "../../../../components/Common/EpmsImage";
import makeStyles from "@material-ui/core/styles/makeStyles";
import SubjectSelector from "../../Components/SubjectSelector";
import {
  PRODUCT_DIGITAL_FILE_UUID,
  PRODUCT_DIGITAL_GROUP_FILE_UUID,
  PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID,
  usePriceList,
} from "../../../providers/PriceListProvider";
import Button from "@material-ui/core/Button";
import { callAPI } from "../../../../lib/common";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { generatePath, useHistory } from "react-router";
import useRoutes from "../../../hooks/useRoutes";
import { usePortal } from "../../../../Providers/PortalProvider";
import { formatCurrency } from "../../../../utils";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import usePictureSetsAvailableToBuyDigitally from "../../../hooks/usePictureSetsAvailableToBuyDigitally";
import * as PropTypes from "prop-types";
import { filterBuyablePictures } from "../../../../lib/DigitalFiles";
import Icon from "@material-ui/core/Icon";
import styled from "styled-components";
import ProductPriceInfoPopup from "../../Components/ProductPriceInfoPopup";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
  },
  heading: {
    fontWeight: 300,
    fontSize: "30px",
    color: theme.palette.primary.dark,
  },
  subHeading: {
    color: theme.palette.primary.main,
    fontSize: "12px",
  },
  imageContainer: {
    flexGrow: 1,
    padding: 0,
    "& img": {
      width: "100%",
      border: `1px solid ${theme.palette.primary.light}`,
    },
  },
  topContainer: { marginBottom: theme.spacing(2), textAlign: "center" },
  oldPrice: {
    color: "rgba(0, 0, 0, 0.6)",
    textDecoration: "line-through",
  },
  currentPrice: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
  },
  singleFilePriceContainer: {},
  cardActions: {
    justifyContent: "space-between",
    paddingRight: 0,
    paddingLeft: 0,
  },
  buyCompleteSetContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
}));

const PricesContainer = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary.dark.color};
  .material-icons {
    margin-right: 8px;
  }
`;

function PictureSetPictures({
  pictures,
  pictureSet,
  product,
  boughtImagesOfType,
}) {
  const classes = useStyles();
  const { update: updatePictureSets } = usePictureSets();
  const portal = usePortal();
  const { digitalRebate } = portal.webshop;
  const { updateCart, qualifyForDigitalRebate } = useShoppingCart();
  const { getPricePerUnit } = usePriceList();

  let priceWithOneMoreItem = 0;
  let priceWithOneMoreCampaignItem = 0;
  let hasCampaignPrice = !!product.productprices[0].campaignprice;
  if (product) {
    priceWithOneMoreItem = getPricePerUnit(
      product,
      boughtImagesOfType.length + 1,
      false,
    );
    priceWithOneMoreCampaignItem = getPricePerUnit(
      product,
      boughtImagesOfType.length + 1,
      hasCampaignPrice,
    );
  }

  const toggleFileInCart = (file) => {
    callAPI("/ajax/cart/toggle_digital_file_in_cart.php", "POST", {
      file: file.uuid,
    })
      .then((data) => {
        if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
          window.epmsAnalytics.onCartChange(data);
        }
        console.log("Toggle file", data);
        updatePictureSets().then(updateCart);
      })
      .catch((err) => {
        console.log("Toggle digital file", err);
      });
  };

  const isIndividualPortrait = product.uuid === PRODUCT_DIGITAL_FILE_UUID;
  const qualifyForDigitalPortraitRebate =
    qualifyForDigitalRebate && isIndividualPortrait;

  const getProductPriceByProductAndBoughtPictures = (
    product,
    picture,
    pictureList,
    getPricePerUnit,
    disableCampaign,
  ) => {
    console.log(
      "And bought",
      product,
      picture,
      product.productprices[0].campaignprice,
    );
    if (product.productprices[0].type == 0) {
      console.log("Yey!!!");
      return getPricePerUnit(
        product,
        pictureList.length,
        !disableCampaign && product.productprices[0].campaignprice,
      );
    }
    const index = pictureList.findIndex((p) => p.uuid === picture.uuid);
    if (index < 0) {
      // Fixme: Should never happen?
      return product.productprices[0].price;
    }

    let lastProductPrice = product.productprices[0].price;
    for (const productPrice of product.productprices) {
      if (productPrice.quantity > index + 1) {
        break;
      }
      lastProductPrice = productPrice.price;
    }
    return lastProductPrice;
  };

  const shouldShowBuySingleFileActions =
    (product &&
      !pictureSet.bought &&
      product.uuid === PRODUCT_DIGITAL_FILE_UUID) ||
    product.uuid !== PRODUCT_DIGITAL_FILE_UUID;

  let doQualifyForDigitalRebate =
    product &&
    product.uuid === PRODUCT_DIGITAL_FILE_UUID &&
    qualifyForDigitalRebate &&
    digitalRebate.rebatedDigitalFilePrice > 0;

  return (
    <Grid container spacing={3}>
      {pictures.map((picture) => {
        return (
          <Grid
            item
            xs={12}
            md={4}
            sm={6}
            className={classes.card}
            key={`${picture.uuid}`}
          >
            <div className={classes.imageContainer}>
              <EpmsImage uuid={picture.uuid} />
            </div>
            {shouldShowBuySingleFileActions && (
              <CardActions classes={{ root: classes.cardActions }}>
                {doQualifyForDigitalRebate && (
                  <div className={classes.singleFilePriceContainer}>
                    <div className={classes.oldPrice}>
                      {formatCurrency(product.productprices[0].price)}
                    </div>
                    <div className={classes.currentPrice}>
                      {" "}
                      {formatCurrency(digitalRebate.rebatedDigitalFilePrice)}
                    </div>
                  </div>
                )}

                {!doQualifyForDigitalRebate && !hasCampaignPrice && (
                  <div className={classes.singleFilePriceContainer}>
                    <div className={classes.currentPrice}>
                      {formatCurrency(
                        picture.inCart
                          ? getProductPriceByProductAndBoughtPictures(
                              product,
                              picture,
                              boughtImagesOfType,
                              getPricePerUnit,
                            )
                          : parseFloat(priceWithOneMoreItem),
                      )}
                    </div>
                  </div>
                )}

                {!doQualifyForDigitalRebate && hasCampaignPrice && (
                  <div className={classes.singleFilePriceContainer}>
                    <div className={classes.oldPrice}>
                      {formatCurrency(
                        picture.inCart
                          ? getProductPriceByProductAndBoughtPictures(
                              product,
                              picture,
                              boughtImagesOfType,
                              getPricePerUnit,
                              true,
                            )
                          : parseFloat(priceWithOneMoreItem),
                      )}
                    </div>
                    <div className={classes.currentPrice}>
                      {" "}
                      {formatCurrency(
                        picture.inCart
                          ? getProductPriceByProductAndBoughtPictures(
                              product,
                              picture,
                              boughtImagesOfType,
                              getPricePerUnit,
                            )
                          : parseFloat(priceWithOneMoreCampaignItem),
                      )}
                    </div>
                  </div>
                )}

                {isIndividualPortrait && pictureSet.inCart && (
                  <Button color="primary" disabled={true}>
                    <Trans>Picture set in cart</Trans>
                  </Button>
                )}

                {(!isIndividualPortrait || !pictureSet.inCart) &&
                  !picture.inCart && (
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => toggleFileInCart(picture)}
                    >
                      <Trans>Buy digital picture</Trans>
                    </Button>
                  )}

                {((isIndividualPortrait && !pictureSet.inCart) ||
                  !isIndividualPortrait) &&
                  picture.inCart && (
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => toggleFileInCart(picture)}
                    >
                      <Trans>Remove from cart</Trans>
                    </Button>
                  )}
              </CardActions>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
}

PictureSetPictures.propTypes = { pictures: PropTypes.any };
export default () => {
  const { params } = useRouteMatch();
  const { notFound, pictureSet } = usePictureSet(params.subjectUuid);
  const {
    update: updatePictureSets,
    isLoaded,
    currentPictureSet,
    pictureSets,
    setCurrentPictureSet,
  } = usePictureSets();
  const pictureSetsAvailableToBuyDigitally =
    usePictureSetsAvailableToBuyDigitally();
  const { getProductByUuid } = usePriceList();
  const { updateCart, qualifyForDigitalRebate } = useShoppingCart();
  const classes = useStyles();
  const routes = useRoutes();
  const history = useHistory();
  const isFirstLoad = useRef(true);
  const { t } = useTranslation();

  // If we change the subject in the selector, reload the page:
  useEffect(() => {
    if (!currentPictureSet) {
      return;
    }

    // The first load, we need to respect the path, afterwards we update path/url from currentSubject:
    if (isFirstLoad.current) {
      if (currentPictureSet.subject.uuid != params.subjectUuid) {
        const pictureSet = pictureSets.find(
          (pictureSet) => pictureSet.subject.uuid == params.subjectUuid,
        );
        if (pictureSet) {
          setCurrentPictureSet(pictureSet);
        }
      }
      isFirstLoad.current = false;
    } else if (currentPictureSet.subject.uuid != params.subjectUuid) {
      const link = generatePath(
        routes["products.digitalportraits.subject"].path,
        { subjectUuid: currentPictureSet.subject.uuid },
      );
      history.replace(link);
    }
  }, [currentPictureSet, params.subjectUuid]);

  const toggleSetInCart = () => {
    const ps = pictureSet;
    return () => {
      console.log("The picture set", ps);
      callAPI("/ajax/cart/toggle_digital_set_in_cart.php", "POST", {
        pictureSet: ps.subject.uuid,
      }).then((data) => {
        if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
          window.epmsAnalytics.onCartChange(data);
        }
        updatePictureSets().then(updateCart);
      });
    };
  };

  const digitalSetProduct = useMemo(() => {
    return getProductByUuid("9c99830e-b4ae-4afb-b1cf-b6f445c1806d");
  }, []);

  const pictures = useMemo(() => {
    return (
      pictureSet &&
      filterBuyablePictures(pictureSet.pictures, getProductByUuid)
    );
  }, [pictureSet]);

  console.log("Pictures", pictures);

  const filteredPictureSets = useMemo(() => {
    if (!pictureSets) {
      return [];
    }
    return pictureSets.map((pictureSet) => {
      if (
        !pictureSetsAvailableToBuyDigitally.find(
          (ps) => ps.subject.uuid === pictureSet.subject.uuid,
        )
      ) {
        return { ...pictureSet, disabled: true };
      }
      return pictureSet;
    });
  }, [pictureSets, pictureSetsAvailableToBuyDigitally]);

  const individualPictures =
    pictures?.filter(
      (picture) => picture.pictureType === "IP" && !picture.bought,
    ) || [];
  const miniGroupPictures =
    pictures?.filter(
      (picture) => picture.pictureType === "MGP" && !picture.bought,
    ) || [];
  const groupPictures =
    pictures?.filter(
      (picture) => picture.pictureType === "GP" && !picture.bought,
    ) || [];

  const digitalPortraitProduct = getProductByUuid(PRODUCT_DIGITAL_FILE_UUID);
  const digitalMiniGroupProduct = getProductByUuid(
    PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID,
  );
  const digitalGroupProduct = getProductByUuid(
    PRODUCT_DIGITAL_GROUP_FILE_UUID,
  );

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Buy digital pictures</Trans>
      </PageHeader>

      <Box mb={4}>
        <SubjectSelector pictureSets={filteredPictureSets} />
      </Box>

      {pictureSet &&
        !pictureSet.bought &&
        individualPictures.length > 0 &&
        (digitalPortraitProduct || digitalSetProduct) && (
          <PictureSetType
            digitalSetProduct={digitalSetProduct}
            singleFileProduct={digitalPortraitProduct}
            pictures={individualPictures}
            toggleSetInCart={toggleSetInCart}
            pictureSet={pictureSet}
            title={t("Portrait pictures")}
          />
        )}

      {miniGroupPictures.length > 0 && digitalMiniGroupProduct && (
        <PictureSetType
          digitalSetProduct={null}
          singleFileProduct={digitalMiniGroupProduct}
          pictures={miniGroupPictures}
          toggleSetInCart={toggleSetInCart}
          pictureSet={pictureSet}
          title={t("Sibling and friend pictures")}
        />
      )}

      {groupPictures.length > 0 && digitalGroupProduct && (
        <PictureSetType
          digitalSetProduct={null}
          singleFileProduct={digitalGroupProduct}
          pictures={groupPictures}
          toggleSetInCart={toggleSetInCart}
          pictureSet={pictureSet}
          title={t("Group pictures")}
        />
      )}
    </MobilePage>
  );
};

const PictureSetType = ({
  digitalSetProduct,
  pictures,
  title,
  singleFileProduct,
  toggleSetInCart,
  pictureSet,
}) => {
  const classes = useStyles();
  const { qualifyForDigitalRebate } = useShoppingCart();
  const portal = usePortal();
  const { digitalRebate } = portal.webshop;
  const { t } = useTranslation();
  const [showPriceDialog, setShowPriceDialog] = useState(null);

  const boughtImagesOfType = pictures.filter((picture) => picture.inCart);

  let rebatedPrice = null;

  console.log("Digital set product", digitalSetProduct);
  const digitalRebatePrice = digitalRebate?.rebatedDigitalSetPrice;
  const campaignPrice = digitalSetProduct?.productprices[0].campaignprice;
  const originalPrice = parseFloat(digitalSetProduct?.productprices[0].price);

  if (qualifyForDigitalRebate && digitalRebatePrice >= 0) {
    rebatedPrice = digitalRebatePrice;
  } else if (campaignPrice) {
    rebatedPrice = campaignPrice;
  }

  return (
    <Box mb={1}>
      <Container maxWidth="md" disableGutters={true}>
        <Card raised={false} fullWidth>
          {pictureSet && (
            <CardContent>
              <div className={classes.topContainer}>
                <div>
                  <div className={classes.heading}>{title}</div>
                </div>
                {singleFileProduct.productprices.length > 1 && (
                  <Box display="flex" justifyContent="center">
                    <PricesContainer
                      onClick={() => setShowPriceDialog(singleFileProduct)}
                    >
                      <Icon>info</Icon>
                      <Trans>Prices</Trans>
                    </PricesContainer>
                  </Box>
                )}
                <div className={classes.subHeading}>
                  {t("%d pictures", {
                    postProcess: "sprintf",
                    sprintf: [pictures.length],
                  })}
                </div>
              </div>
              {digitalSetProduct && (
                <Box display="flex" justifyContent="space-between" mb={2}>
                  {!pictureSet.bought && (
                    <div className={classes.buyCompleteSetContainer}>
                      <div>
                        {rebatedPrice && (
                          <div>
                            <div className={classes.oldPrice}>
                              {formatCurrency(originalPrice)}
                            </div>
                            <div className={classes.currentPrice}>
                              {formatCurrency(rebatedPrice)}
                            </div>
                          </div>
                        )}
                        {!rebatedPrice && (
                          <div>
                            <div className={classes.currentPrice}>
                              {formatCurrency(originalPrice)}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <Box>
                    {!pictureSet?.inCart && (
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={toggleSetInCart()}
                      >
                        <Trans>Buy portrait set</Trans>
                      </Button>
                    )}
                    {pictureSet?.inCart && (
                      <Button
                        color="primary"
                        variant="outlined"
                        onClick={toggleSetInCart()}
                      >
                        <Trans>Remove from cart</Trans>
                      </Button>
                    )}
                  </Box>
                </Box>
              )}

              {pictures && singleFileProduct && (
                <>
                  <PictureSetPictures
                    pictureSet={pictureSet}
                    pictures={pictures}
                    product={singleFileProduct}
                    boughtImagesOfType={boughtImagesOfType}
                  />
                </>
              )}
            </CardContent>
          )}
        </Card>
        {showPriceDialog && (
          <ProductPriceInfoPopup
            open={true}
            product={showPriceDialog}
            handleClose={() => setShowPriceDialog(null)}
          />
        )}
      </Container>
    </Box>
  );
};
